module.exports = __webpack_public_path__ + "static/media/back-seat.119a4928.svg";